import { last } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import * as waveActions from '../actions/wave.actions';
import {
  selectedWavesSelector,
  waveForIdsSelector,
} from '../selectors/wave.selectors';
import { WaveId } from '../types/wave.type';

interface Options {
  unselectOthers: boolean;
}

export const toggleWaves = (
  ids: WaveId[],
  { unselectOthers }: Options,
): AppThunk => async (dispatch, getState) => {
  const state = getState();
  const waves = waveForIdsSelector(ids)(state);
  const selectedWaves = selectedWavesSelector(state);

  const lastWave = last(waves);
  if (!lastWave) {
    return;
  }

  const isOfSameType = selectedWaves.every(
    ({ type }) => type === lastWave.type,
  );

  if (!isOfSameType || unselectOthers) {
    dispatch(waveActions.unselectAll({ meta: { history: false } }));
  }

  const allowedType = lastWave.type;
  const allowedWaves = waves.filter(({ type }) => type === allowedType);

  if (allowedWaves.length > 0) {
    dispatch(waveActions.toggle({ waveIds: allowedWaves.map(({ id }) => id) }));
  }
};
